/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu May 12 2021 04:30:00 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { Banner, Button, TextStyle } from '@shopify/polaris';

import ChangePlanFromReviewIOModal from 'src/components/views/common/change-plan-from-reviewio-modal';

type Props = {
  subscription: Object
};

type ComposedProps = Props & WithI18nProps;

const ExceededPlanNotification: React.FC<ComposedProps> = ({ subscription, i18n }) => {
  const { status, isFirst7Days, useBoltOn } = subscription;
  const [changePlanFromReviewIOModal, setChangePlanFromReviewIOModal] = useState(false);

  if (status === 'exceededWithNotification') {
    const content = isFirst7Days
      ? i18n.translate('AdminHTML.Common.ExceededPlanNotification.content1', {
          t1: (
            <TextStyle variation="strong">
              {i18n.translate('AdminHTML.Common.ExceededPlanNotification.content1_t1')}
            </TextStyle>
          ),
          t2: (
            <Button
              plain
              onClick={() => {
                useBoltOn
                  ? setChangePlanFromReviewIOModal(true)
                  : history.push(routes.subscription.plan());
              }}>
              {i18n.translate('AdminHTML.Common.ExceededPlanNotification.content1_t2')}
            </Button>
          )
        })
      : i18n.translate('AdminHTML.Common.ExceededPlanNotification.content2', {
          t: (
            <Button
              plain
              onClick={() => {
                useBoltOn
                  ? setChangePlanFromReviewIOModal(true)
                  : history.push(routes.subscription.plan());
              }}>
              {i18n.translate('AdminHTML.Common.ExceededPlanNotification.content2_t')}
            </Button>
          )
        });

    return (
      <div className="exceededPlanNotification">
        <div className="notification">
          <Banner
            title={i18n.translate('AdminHTML.Common.ExceededPlanNotification.title')}
            status="warning">
            {content}
          </Banner>
        </div>
        <ChangePlanFromReviewIOModal
          open={changePlanFromReviewIOModal}
          onClose={() => setChangePlanFromReviewIOModal(false)}
        />
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => ({
  subscription: _.get(state.oauth, 'subscription', {})
});

export default connect(mapStateToProps)(withI18n()(ExceededPlanNotification));
